<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form class="d-flex align-items-center justify-content-between gap-2 flex-wrap" (ngSubmit)="search()">
      <div class="d-flex align-items-center gap-2">
        <div class="input-group input-group-sm master-search-group">
          <input type="text" class="form-control" name="term"
                 placeholder="ค้นหาจากชื่อคู่สนทนา"
                 title="ค้นหา"
                 [ngModel]="term()"
                 (ngModelChange)="term.set($event)"/>
          <button class="btn btn-default" type="submit" title="ค้นหา">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-default" (click)="reset()">ล้าง</button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <button type="button" class="btn btn-sm btn-outline-secondary"
                [disabled]="selectedIds().size === 0"
                (click)="exportSelected()">
          <i class="bi bi-file-earmark-arrow-down me-1"></i>ส่งออกไฟล์
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger"
                [disabled]="selectedIds().size === 0"
                (click)="deleteSelected()">
          <i class="bi bi-trash me-1"></i>ลบ
        </button>
      </div>
    </form>
  </div>

  <div class="card-subheader px-3 py-2 border-bottom bg-white d-flex align-items-center gap-2">
    <span class="text-body-secondary small">Show</span>
    <app-pagesize-select size="sm" [value]="pageData().page.size" [options]="[10, 15, 20, 50, 100]"
                         (valueChange)="onPageSizeChange($event)"/>
    <span class="text-body-secondary small">entries</span>
    @if (selectedIds().size > 0) {
      <span class="text-body-secondary small ms-auto">เลือกไว้ {{ selectedIds().size }} รายการ</span>
    }
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0 align-middle">
        <thead class="bg-light">
          <tr>
            <th nowrap class="text-center">No.</th>
            <th nowrap class="text-center">
              <input type="checkbox" class="form-check-input" title="เลือกทั้งหมด"
                     [checked]="allSelected" (change)="toggleSelectAll()"/>
            </th>
            <th nowrap role="button" (click)="sortBy('userName')">
              ชื่อคู่สนทนา <i class="bi ms-1" [class]="sortIcon('userName')"></i>
            </th>
            <th nowrap role="button" (click)="sortBy('updateTime')">
              สิ้นสุดการสนทนา <i class="bi ms-1" [class]="sortIcon('updateTime')"></i>
            </th>
            <th nowrap class="text-end">จำนวนข้อความ</th>
            <th nowrap class="text-center" role="button" (click)="sortBy('platform')">
              ช่องทาง <i class="bi ms-1" [class]="sortIcon('platform')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          @if ((pageData().content?.length ?? 0) === 0) {
            <tr>
              <td colspan="6" class="text-center py-4 text-body-secondary">ไม่พบข้อมูล</td>
            </tr>
          } @else {
            @for (row of pageData().content; track row.id; let i = $index) {
              <tr>
                <td class="text-center">{{ rowNo(i) }}</td>
                <td class="text-center">
                  <input type="checkbox" class="form-check-input"
                         [checked]="isSelected(row.id)" (change)="toggleSelect(row.id)"/>
                </td>
                <td>
                  <a href="javascript:void(0)" (click)="openDetail(row)">{{ row.userName || '-' }}</a>
                </td>
                <td nowrap>{{ toDate(row.updateTime) | thaidatetime:LONG_DATE }}</td>
                <td class="text-end">{{ row.messageCount }}</td>
                <td class="text-center">
                  <span class="platform-badge" [class]="platformClass(row.platform)">
                    {{ platformLabel(row.platform) }}
                  </span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <span class="text-body-secondary small">Total {{ pageData().page?.totalElements ?? 0 }} records</span>
    <ngb-pagination [collectionSize]="pageData().page.totalElements ?? 0"
                    [page]="(pageData().page?.number ?? 0) + 1"
                    [pageSize]="pageData().page.size"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="search($event)">
    </ngb-pagination>
  </div>
</div>

@if (message()) {
  <div class="alert alert-info alert-dismissible fade show" role="alert">
    {{ message() }}
    <button type="button" class="btn-close" (click)="message.set(null)" aria-label="Close"></button>
  </div>
}
